const messages = {
    cover: {
        title: '/እንኳን ደህና መጡ. ፎንቶችን በነጻ ዳውንሎድ ያድርጉ.',
        am: '/በአሁን ላይ 5 ስታየልስ አሉን. ሑሉም ፎንቶች ከትንሽ ፎንቶች ጀምሮ እንዲሰሩ ተደርጎ ዲዛይን ተደርገዋል. ለ ድረ-ገጽ, መጽሃፍ, ፕሪንት ይጠቀሙበት. ለመማር እና ለማየት, ከታች ባሉት ሊንኮች ይከተሉን. ካፒታል ቃላትን ዕና ዐዳዲስ ፎንቶችን ለማስተዋወቅ ሞክረናል.',
        eng: "Currently we have 5 downloadable fonts. They are designed to work from small (12pts). Use them for your websites and print media. We have also introduced the use of Capital letters for the Geez-based laguages.",
        derassi: '/ደራሲ በ /ሙላት የተሰራ ወርድ ፕሮሰሰር ነው. ይሞክሩት, ብዙ ፎንቶች አሉት. Try Derassi App by Mulat'
    },
    abay: {
        para1: '/የመደመር ዕሴት የዜጎች ክብር ነው.',
        para2: '/ኢትዮጵያን በሃገር ውስጥም ይሁን በውጭ ሃገር, ክብራቸው ተጠብቆና ሀገራቸውን መከታ አድርገው እንዲኖሩ ቅድሚያ ሰጥቶ የመስራት ፍላጎ ነው.',
        para3: '/መደመር - ገፅ 54',
        about: {
            am: '/ለዌብ ለፕሪንት እና ለመሳሰሉ ሚዲያዎች ይስማማል. Comes in Regular, Thin, Bold and their Italic counter parts',
            eng: 'Suggested for web and print media',
        },
    },
    awash: {
        para1: '/ኢትዮጵያ',
        para2: '/ኢትዮጵያ በልጆችዋ ጥረት ታፍራና ተከብራ ለዘላለም ትኑር. ፈጣሪ ኢትዮጵያን እና ልጆችዋን ይባርክ.',
        para3: '/ዶር. /አብይ /አህመድ',
        about: {
            am: '/ለንግድ ሳይን እና ለካርድ ይስማማል. Comes in Regular sub style',
            eng: 'Suggested for store front signs, cards...',
        },
    },
    addis: {
        para1: '. ቋንቋችን መቀየር ይሮርበታል .',
        para2: '/ይህ ካልሆነ እድገታችን እንደጫጨ, ፍትሃችን እንደጨነገፈ, ኢኮኖሚያችን እንደተዳከመ መኖራችን ይቀጥላል.',
        para3: '/መደመር - ገፅ 54',
        about: {
            am: '/ለዌብ ለፕሪንት እር ለመሳሰሉ ሚዲያዎች ይስማማል. Comes in Regular sub style',
            eng: 'Suggested for web and print media',
        },
    },
    ahmed: {
        para1: '/አፈጣጠር ከትንንሽ ነገሮች መሰባሰብ የመጣ ነው.',
        para2: '/ተፈጥሮ እውን የሆነችው, ትንንሽ ነገሮች ተሰባስበው ትልልቅ ነገሮችን እየፈጠሩ ነው.',
        para3: '/መደመር - ገፅ 32',
        about: {
            am: '/ለዌብ ለፕሪንት እር ለመሳሰሉ ሚዲያዎች ይስማማል. Comes in Regular sub style',
            eng: 'Suggested for web and print media',
        },
    },
    asmara: {
        para1: '/አፈጣጠር ከትንንሽ ነገሮች መሰባሰብ የመጣ ነው.',
        para2: '/ተፈጥሮ እውን የሆነችው, ትንንሽ ነገሮች ተሰባስበው ትልልቅ ነገሮችን እየፈጠሩ ነው.',
        para3: '/መደመር - ገፅ 32',
        about: {
            am: '/ለዌብ ለፕሪንት እር ለመሳሰሉ ሚዲያዎች ይስማማል. Comes in Regular sub style',
            eng: 'Suggested for web and print media',
        },
    },
    motivation: {
        mot1: {
            title: '/አ/ላ/ማ',
            message: '/የ /ሙላት እላማ, በ /ኢትዮጵያ እና በ /ኤርትራ ለሚገኙ ተማሪዎች እር የንግድ ኣካላቶች ሰነዶችን የሚያዘገጁበት መሳሪያ ይሆን ዘንድ ነው.',
        },
        mot2: {
            title: '/ቴ/ክ',
            message: '/ሙላት የግእዝ ስልቶችን ከ ላቲን ስልቶች ጋር ለማገንኘት ይሞክራል. /ምክንያቱም, ብዙ ቴክኖሎጂ እና ብዙ ማሽኖች የተመቻቹት ለ /ላቲን ወዪም /እንግሊዘኛ ነው. /ለምሳሌ ሞባይል ስልክ. /የዓዳዲስ ፎንቶች ፍጥረት, ለሞብይል እንዲመቹ እና እንዲያምሩ ይረዳል. /ቴክኖሎጂ ሲቀየር ቋንቋ መቀየር ዐለበት. /ኣለበለዚያ ህዝብና ስልጣኔ ሊለያዩ ይችላሉ.',
        },
        mot3: {
            title: '/ዕ/ድ/ገ/ት',
            message: '/ሙላት ገና መጀመሩ ነው. /ቀስ እያለ ሊጠነክር እና ሊስፋፋ ይችላል. /ለዚህም እርዳታዎ እንዳይለየን እንጠይቃለን. ሙላት በዙ ፕሮጀኽቶች ወደፊት ዪሮሩታል. /ዐሁን ለጊዜው በፎንት ዲዛየን እና /ደራሲ ላይ ብቻ ነው የምናተኩረው.',
        }
    },
    about: {
        am: '/ሠላም, /ፋሲል እባላለሁ. /በዓሁን ላይ, /ሙላትን የምሰራው ብቻዬን ነው. /ሙላት በጣም የማምንበት ፕሮጀኽት ነው. /የሚቻለዎ ከሆነ, ያግዙኝ. በገንዘብ, በሃሳብ, ኮድ በማድረግ, ወዘተ...ከታች በሚገኙት ሊንኮች. /እግዚኣብሄር ዪስጥልኝ.',
        eng: 'Hello my name is Fasil. I currently work on Mulat project solo. If you are able to help with donations, ideas, code contribution etc.... please connect on the links below. Thanks',
    },
    shareMessage: {
        m1: {
            am: 'https://mulat.org',
            eng: 'https://mulat.org',
        },
        m2: {
            am: 'እነዚህን ፎንቶች ይመልከቱ \n checkout these Geez font styles',
            eng: 'checkout these Geez font styles',
        }
    },
    words:
        //[ 'የመደመር ዕሴት የዜጎች ክብር ነው.',
        // '/ኢትዮጵያን በሃገር ውስጥም ይሁን በውጭ ሃገር,', 
        //  '/ክብራቸው ተጠብቆና ሀገራቸውን መከታ አድርገው እንዲኖሩ', 
        //   'ቅድሚያ ሰጥቶ የመስራት ፍላጎ ነው.',
        // '/ኢትዮጵያ በልጆችዋ ጥረት ታፍራና ተከብራ ለዘላለም ትኑር.', 
        //  'ፈጣሪ ኢትዮጵያን እና ልጆችዋን ይባርክ.',
        // '/ዶር. /አብይ /አህመድ.',
        // '/ቋንቋችን መቀየር ይሮርበታል.',
        // '/ይህ ካልሆነ እድገታችን እንደጫጨ, ፍትሃችን እንደጨነገፈ,',
        //   'ኢኮኖሚያችን እንደተዳከመ መኖራችን ይቀጥላል.',
        // '/አፈጣጠር ከትንንሽ ነገሮች መሰባሰብ የመጣ ነው.',
        // '/ተፈጥሮ እውን የሆነችው, ትንንሽ ነገሮች ተሰባስበው ትልልቅ ነገሮችን እየፈጠሩ ነው.',
        // '/ኢትዮጵያ እና /ኤርትራ',
        //  '/ኣፍሪካ  ኣንድ ናት, ትሆናለች.',
        //  'ኣፍሪካ ዐሜሪካ በጣም እወድሻለሁ',
        //   'እናት ሀገር በጣም እወድሻለሁ']
        ['አርማሽ ይውለብለብ ከደጄ. ',
            'ልቤ ናፍቆሻል ወዳጄ. ',
            'እኔስ እስካይሽ ጨነቀኝ. ',
            'ሀገሬ መምጫሽ ናፈቀኝ. ',
            'ቀን እየሄደ ቀን መጣ. ',
            'ልቤ ከሀሳብ ሳይወጣ. ',
            'መጥታ ታብሰው እንባዬን. ',
            'ሀገሬን ጥሯት አርማዬን. ',
            'መቼም ከዚህ ምድር ላይ ሄዶ ነው ሁሉም ቀሪ. ',
            'አገር ናት ቋሚ ሰንደቅ ለዘላለም ኗሪ. ',
            'ትላንትም እንደ ጀምበር እያዩት ካይን ይርቃል. ',
            'ኢትዮጵያ እንድትመጪ ስንት ቀን ይበቃል. ',
            'እኔማ ላይሽ በቶሎ ምኞት ነበረኝ. ',
            'ግን ባባሁ ናፈኩሽ እና ዕምባ ቀደመኝ. ',
            'እኔማ አለሁ እስካሁን ተስፋ ሰንቄ. ',
            'በወንዜ ባገሬ እያለሁ አገር ናፍቄ. ']

};

export default messages;
